import React, { createContext, useContext, useState, useEffect } from 'react';


const OfflineContext = createContext();


export const useOffline = () => {
  const context = useContext(OfflineContext);
  if (!context) {
    throw new Error('useOffline must be used within an OfflineProvider');
  }
  return context;
};


export const OfflineProvider = ({ children }) => {

  const [isOffline, setIsOffline] = useState(() => {
    const saved = localStorage.getItem('scladro_offline_mode');
    return saved ? JSON.parse(saved) : false;
  });


  const toggleOfflineState = () => {
    const newState = !isOffline;
    setIsOffline(newState);
    localStorage.setItem('scladro_offline_mode', JSON.stringify(newState));
    

    window.dispatchEvent(new CustomEvent('scladro_offline_change', {
      detail: { isOffline: newState }
    }));
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'scladro_offline_mode') {
        const newValue = e.newValue ? JSON.parse(e.newValue) : false;
        setIsOffline(newValue);
      }
    };

    const handleOfflineChange = (e) => {
      setIsOffline(e.detail.isOffline);
    };


    window.addEventListener('storage', handleStorageChange);

    window.addEventListener('scladro_offline_change', handleOfflineChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('scladro_offline_change', handleOfflineChange);
    };
  }, []);

  const value = {
    isOffline,
    toggleOfflineState
  };

  return (
    <OfflineContext.Provider value={value}>
      {children}
    </OfflineContext.Provider>
  );
};

export default OfflineContext; 